/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import { AppRouterContext } from './stores';
import { AppRouterContent } from './components';
import { RouterStore } from '../../stores/router';
import {
    useGlobalAddons,
    useGlobalAppData,
    useGlobalContext,
    useGlobalRoutes,
} from '../providers/GlobalContextProvider';

const baseName = process.env.NODE_ENV === 'production' ? process.env.PUBLIC_URL : (process.env.DEV_PUBLIC_URL ?? '');

export const AppRouter: React.FC<{}> = observer(() => {
    const { getLoginPath } = useGlobalContext();
    const { portalUser } = useGlobalAppData();
    const routes = useGlobalRoutes();
    const { portalFeatures, portalPreferences } = useGlobalAddons();
    const appRouterStore = useMemo(
        () => new RouterStore({
            routes,
            portalUser,
            portalFeatures,
            portalPreferences,
            getLoginPath,
        }),
        [routes, portalUser, portalFeatures?.features, portalPreferences?.preferences, portalPreferences?.preferencesWithoutPortalFilter]
    );

    return (
        <AppRouterContext.Provider value={appRouterStore}>
            <BrowserRouter basename={baseName}>
                <AppRouterContent />
            </BrowserRouter>
        </AppRouterContext.Provider>
    );
});

